import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

const translations = {
  en: {
    home: "Home",
    marketplace: "Marketplace",
    about: "About",
    contact: "Contact",
    login: "Login",
    register: "Register",
    dashboard: "Dashboard",
    logout: "Logout",
    heroTitle: "Authentic Algerian Craftsmanship",
    heroSubtitle: "Discover the soul of Algeria through handmade treasures from local artisans.",
    shopNow: "Shop Now",
    joinAsSeller: "Join as Artisan",
    featuredProducts: "Featured Collections",
    howItWorks: "How It Works",
    footerText: "Made with ❤️ in Algeria",
    cart: "Cart",
    search: "Search...",
    categories: "Categories",
    price: "Price",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    checkout: "Checkout",
    cod: "Cash on Delivery",
    sellerDashboard: "Seller Dashboard",
    addProduct: "Add Product",
    myStore: "My Store",
    orders: "Orders",
    welcome: "Welcome",
    storeName: "Store Name",
  },
  fr: {
    home: "Accueil",
    marketplace: "Boutique",
    about: "À propos",
    contact: "Contact",
    login: "Connexion",
    register: "S'inscrire",
    dashboard: "Tableau de bord",
    logout: "Déconnexion",
    heroTitle: "Artisanat Algérien Authentique",
    heroSubtitle: "Découvrez l'âme de l'Algérie à travers des trésors faits main.",
    shopNow: "Acheter",
    joinAsSeller: "Devenir Artisan",
    featuredProducts: "Collections en Vedette",
    howItWorks: "Comment ça marche",
    footerText: "Fait avec ❤️ en Algérie",
    cart: "Panier",
    search: "Rechercher...",
    categories: "Catégories",
    price: "Prix",
    addToCart: "Ajouter au panier",
    buyNow: "Acheter maintenant",
    checkout: "Commander",
    cod: "Paiement à la livraison",
    sellerDashboard: "Tableau de bord Vendeur",
    addProduct: "Ajouter un produit",
    myStore: "Ma Boutique",
    orders: "Commandes",
    welcome: "Bienvenue",
    storeName: "Nom de la boutique",
  },
  ar: {
    home: "الرئيسية",
    marketplace: "المتجر",
    about: "من نحن",
    contact: "اتصل بنا",
    login: "دخول",
    register: "تسجيل",
    dashboard: "لوحة التحكم",
    logout: "خروج",
    heroTitle: "حرف يدوية جزائرية أصيلة",
    heroSubtitle: "اكتشف روح الجزائر من خلال الكنوز المصنوعة يدوياً من قبل حرفيين محليين.",
    shopNow: "تسوق الآن",
    joinAsSeller: "انضم كحرفي",
    featuredProducts: "مجموعات مميزة",
    howItWorks: "كيف يعمل",
    footerText: "صنع بـ ❤️ في الجزائر",
    cart: "السلة",
    search: "بحث...",
    categories: "الفئات",
    price: "السعر",
    addToCart: "أضف للسلة",
    buyNow: "شراء الآن",
    checkout: "الدفع",
    cod: "الدفع عند الاستلام",
    sellerDashboard: "لوحة تحكم البائع",
    addProduct: "أضف منتج",
    myStore: "متجري",
    orders: "الطلبات",
    welcome: "مرحبا",
    storeName: "اسم المتجر",
  }
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const dir = language === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.dir = dir;
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => translations[language][key] || key;

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL: language === 'ar' }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
